export enum EFieldType {
  CHECKBOX = 1,
  TEXT,
  INTEGER,
  DECIMAL,
  DROPDOWN,
  TIMESTAMP,
  DATE,
  YES_NO,
  CALCULATION
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/form-builder/enums/e-field-type.enum.ts